import React from "react";
import { Link } from "react-router-dom";
import { HighlightText } from "../../views/inner-pages/blog-pages/BlogV1"; // adjust the path to where your HighlightText lives

const BlogStyle1 = ({ blogs = [], searchTerm = "" }) => {
  return (
    <>
      {blogs.length > 0 ? (
        blogs.map((item, i) => (
          <div className="col-lg-4 col-md-6" key={i}>
            <div className="post-meta">
              
              <img src={item.imageurl} alt="media" className="image-meta" />

              
              {item.tags && item.tags.length > 0 && (
                <div className="mb-2">
                  {item.tags
                    ?.toString()
                    .split(",")
                    .map((tag, index) => (
                      <span className="tag h1-para me-2" key={index}>
                        {tag.trim()}
                      </span>
                    ))}
                </div>
              )}

              
              <h3 className="h3-heading text-start mt-1 mt-lg-0">
                <Link to={`/blog-details/${item._id}`} className="truncate-1">
                  <HighlightText text={item.mainheading || ""} highlight={searchTerm} />
                </Link>
              </h3>

              
              <p className="truncate-2 mt-2">
                <HighlightText text={item.meta_description || ""} highlight={searchTerm} />
              </p>

             
              <Link
                to={`/blog-details/${item._id}`}
                className="read-more d-flex justify-content-between align-items-center"
              >
                <span className="h3-para text-gradient">Read More</span>
                <i className="flaticon-right-arrow"></i>
              </Link>
            </div>
          </div>
        ))
      ) : (
        <div className="text-center mt-4 w-100">
          <p className="h1-para">No blogs found for this keyword.</p>
        </div>
      )}
    </>
  );
};

export default BlogStyle1;
